<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南侧锚鞍室</h2>
      </div>
      <div class="cable-main">
        <!-- <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁(东)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关(西)</span>
        </div>
        <div class="cable-img">
          <!-- <el-tooltip class="station-block station-block-left" content="1#除湿机组(镇宁侧)" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/balingheSensor/station/left"></router-link>
          </el-tooltip>
          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_dehumidifier("1#除湿机组(镇宁侧)", "", "", runningDehumidifierLeft, malfunctionDehumidifierLeft) }}
              </div>
              <div :class="errorDehumidifierLeft" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p class="bold">1#除湿机组(镇宁侧) <span :class="runningClassLeft" class="valve-sign"></span></p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-middle" content="3#除湿机组(跨中)" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/balingheSensor/station/middle"></router-link>
          </el-tooltip>
          <div class="stati sta-middle">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_dehumidifier("3#除湿机组(跨中)", "", "", runningDehumidifierMiddle, malfunctionDehumidifierMiddle) }}
              </div>
              <div :class="errorDehumidifierMiddle" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p class="bold">3#除湿机组(跨中) <span :class="runningClassMiddle" class="valve-sign"></span></p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="2#除湿机组(胜境关侧)" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/balingheSensor/station/right"></router-link>
          </el-tooltip>
          <div class="stati sta-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_dehumidifier("2#除湿机组(胜境关侧)", "", "", runningDehumidifierRight, malfunctionDehumidifierRight) }}
              </div>
              <div :class="errorDehumidifierRight" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p class="bold">2#除湿机组(胜境关侧) <span :class="runningClassRight" class="valve-sign"></span></p>
              </div>
            </el-tooltip>
          </div> -->

          <div class="clip sensor2 sensor-saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("镇宁南侧鞍室1", humidityTooltipErrorSaddleLeftSouth1, humidityAllowedMaxSaddleLeftSouth1) }}
                <br />
                {{ assembleTooltip_sensor("镇宁南侧鞍室2", humidityTooltipErrorSaddleLeftSouth2, humidityAllowedMaxSaddleLeftSouth2) }}
                <br />
                {{ assembleTooltip_sensor("镇宁南侧鞍室3", humidityTooltipErrorSaddleLeftSouth3, humidityAllowedMaxSaddleLeftSouth3) }}
              </div>
              <div :class="errorSaddleLeftSouth" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">镇宁南侧鞍室</p>
                <p>
                  <span
                    >{{ humiditySaddleLeftSouth1 | toFixed }}% {{ temperatureSaddleLeftSouth1 | toFixed }}°C
                    {{ absHumiditySaddleLeftSouth1 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleLeftSouth2 | toFixed }}% {{ temperatureSaddleLeftSouth2 | toFixed }}°C
                    {{ absHumiditySaddleLeftSouth2 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleLeftSouth3 | toFixed }}% {{ temperatureSaddleLeftSouth3 | toFixed }}°C
                    {{ absHumiditySaddleLeftSouth3 | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("胜境关南侧鞍室1", humidityTooltipErrorSaddleRightSouth1, humidityAllowedMaxSaddleRightSouth1) }}
                <br />
                {{ assembleTooltip_sensor("胜境关南侧鞍室2", humidityTooltipErrorSaddleRightSouth2, humidityAllowedMaxSaddleRightSouth2) }}
                <br />
                {{ assembleTooltip_sensor("胜境关南侧鞍室3", humidityTooltipErrorSaddleRightSouth3, humidityAllowedMaxSaddleRightSouth3) }}
              </div>
              <div :class="errorSaddleRightSouth" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">胜境关南侧鞍室</p>
                <p>
                  <span
                    >{{ humiditySaddleRightSouth1 | toFixed }}% {{ temperatureSaddleRightSouth1 | toFixed }}°C
                    {{ absHumiditySaddleRightSouth1 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleRightSouth2 | toFixed }}% {{ temperatureSaddleRightSouth2 | toFixed }}°C
                    {{ absHumiditySaddleRightSouth2 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleRightSouth3 | toFixed }}% {{ temperatureSaddleRightSouth3 | toFixed }}°C
                    {{ absHumiditySaddleRightSouth3 | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorAnchorLeftSouth, humidityAllowedMaxAnchorLeftSouth) }}
              </div>
              <div :class="errorAnchorLeftSouth" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">镇宁南侧锚室</p>
                <p>
                  <span
                    >{{ humidityAnchorLeftSouth | toFixed }}% {{ temperatureAnchorLeftSouth | toFixed }}°C
                    {{ absHumidityAnchorLeftSouth | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorAnchorRightSouth, humidityAllowedMaxAnchorRightSouth) }}
              </div>
              <div :class="errorAnchorRightSouth" class="state-info top-right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">胜境关南侧锚室</p>
                <p>
                  <span
                    >{{ humidityAnchorRightSouth | toFixed }}% {{ temperatureAnchorRightSouth | toFixed }}°C
                    {{ absHumidityAnchorRightSouth | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北侧锚鞍室</h2>
      </div>
      <div class="cable-main">
        <!-- <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁(东)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关(西)</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor2 sensor-saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("镇宁北侧鞍室1", humidityTooltipErrorSaddleLeftNorth1, humidityAllowedMaxSaddleLeftNorth1) }}
                <br />
                {{ assembleTooltip_sensor("镇宁北侧鞍室2", humidityTooltipErrorSaddleLeftNorth2, humidityAllowedMaxSaddleLeftNorth2) }}
                <br />
                {{ assembleTooltip_sensor("镇宁北侧鞍室3", humidityTooltipErrorSaddleLeftNorth3, humidityAllowedMaxSaddleLeftNorth3) }}
              </div>
              <div :class="errorSaddleLeftNorth" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">镇宁北侧鞍室</p>
                <p>
                  <span
                    >{{ humiditySaddleLeftNorth1 | toFixed }}% {{ temperatureSaddleLeftNorth1 | toFixed }}°C
                    {{ absHumiditySaddleLeftNorth1 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleLeftNorth2 | toFixed }}% {{ temperatureSaddleLeftNorth2 | toFixed }}°C
                    {{ absHumiditySaddleLeftNorth2 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleLeftNorth3 | toFixed }}% {{ temperatureSaddleLeftNorth3 | toFixed }}°C
                    {{ absHumiditySaddleLeftNorth3 | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("胜境关北侧鞍室1", humidityTooltipErrorSaddleRightNorth1, humidityAllowedMaxSaddleRightNorth1) }}
                <br />
                {{ assembleTooltip_sensor("胜境关北侧鞍室2", humidityTooltipErrorSaddleRightNorth2, humidityAllowedMaxSaddleRightNorth2) }}
                <br />
                {{ assembleTooltip_sensor("胜境关北侧鞍室3", humidityTooltipErrorSaddleRightNorth3, humidityAllowedMaxSaddleRightNorth3) }}
              </div>
              <div :class="errorSaddleRightNorth" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">胜境关北侧鞍室</p>
                <p>
                  <span
                    >{{ humiditySaddleRightNorth1 | toFixed }}% {{ temperatureSaddleRightNorth1 | toFixed }}°C
                    {{ absHumiditySaddleRightNorth1 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleRightNorth2 | toFixed }}% {{ temperatureSaddleRightNorth2 | toFixed }}°C
                    {{ absHumiditySaddleRightNorth2 | toFixed }}g/kg</span
                  >
                  <br /><span
                    >{{ humiditySaddleRightNorth3 | toFixed }}% {{ temperatureSaddleRightNorth3 | toFixed }}°C
                    {{ absHumiditySaddleRightNorth3 | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorAnchorLeftNorth, humidityAllowedMaxAnchorLeftNorth) }}
              </div>
              <div :class="errorAnchorLeftNorth" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">镇宁北侧锚室</p>
                <p>
                  <span
                    >{{ humidityAnchorLeftNorth | toFixed }}% {{ temperatureAnchorLeftNorth | toFixed }}°C
                    {{ absHumidityAnchorLeftNorth | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorAnchorRightNorth, humidityAllowedMaxAnchorRightNorth) }}
              </div>
              <div :class="errorAnchorRightNorth" class="state-info top-right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">胜境关北侧锚室</p>
                <p>
                  <span
                    >{{ humidityAnchorRightNorth | toFixed }}% {{ temperatureAnchorRightNorth | toFixed }}°C
                    {{ absHumidityAnchorRightNorth | toFixed }}g/kg</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature, pressure, flow, volume
      humidityDehumidifierLeft: "--",
      humidityDehumidifierMiddle: "--",
      humidityDehumidifierRight: "--",
      humidityAnchorLeftNorth: "--",
      humidityAnchorLeftSouth: "--",
      humidityAnchorRightNorth: "--",
      humidityAnchorRightSouth: "--",
      humiditySaddleLeftNorth1: "--",
      humiditySaddleLeftNorth2: "--",
      humiditySaddleLeftNorth3: "--",
      humiditySaddleLeftSouth1: "--",
      humiditySaddleLeftSouth2: "--",
      humiditySaddleLeftSouth3: "--",
      humiditySaddleRightNorth1: "--",
      humiditySaddleRightNorth2: "--",
      humiditySaddleRightNorth3: "--",
      humiditySaddleRightSouth1: "--",
      humiditySaddleRightSouth2: "--",
      humiditySaddleRightSouth3: "--",

      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierMiddle: "--",
      temperatureDehumidifierRight: "--",
      temperatureAnchorLeftNorth: "--",
      temperatureAnchorLeftSouth: "--",
      temperatureAnchorRightNorth: "--",
      temperatureAnchorRightSouth: "--",
      temperatureSaddleLeftNorth1: "--",
      temperatureSaddleLeftNorth2: "--",
      temperatureSaddleLeftNorth3: "--",
      temperatureSaddleLeftSouth1: "--",
      temperatureSaddleLeftSouth2: "--",
      temperatureSaddleLeftSouth3: "--",
      temperatureSaddleRightNorth1: "--",
      temperatureSaddleRightNorth2: "--",
      temperatureSaddleRightNorth3: "--",
      temperatureSaddleRightSouth1: "--",
      temperatureSaddleRightSouth2: "--",
      temperatureSaddleRightSouth3: "--",

      absHumidityAnchorLeftNorth: "--",
      absHumidityAnchorLeftSouth: "--",
      absHumidityAnchorRightNorth: "--",
      absHumidityAnchorRightSouth: "--",
      absHumiditySaddleLeftNorth1: "--",
      absHumiditySaddleLeftNorth2: "--",
      absHumiditySaddleLeftNorth3: "--",
      absHumiditySaddleLeftSouth1: "--",
      absHumiditySaddleLeftSouth2: "--",
      absHumiditySaddleLeftSouth3: "--",
      absHumiditySaddleRightNorth1: "--",
      absHumiditySaddleRightNorth2: "--",
      absHumiditySaddleRightNorth3: "--",
      absHumiditySaddleRightSouth1: "--",
      absHumiditySaddleRightSouth2: "--",
      absHumiditySaddleRightSouth3: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierMiddle: "--",
      runningDehumidifierRight: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierMiddle: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorDehumidifierLeft: "--",
      errorDehumidifierMiddle: "--",
      errorDehumidifierRight: "--",
      errorAnchorLeftNorth: "--",
      errorAnchorLeftSouth: "--",
      errorAnchorRightNorth: "--",
      errorAnchorRightSouth: "--",
      errorSaddleLeftNorth: "--",
      errorSaddleLeftSouth: "--",
      errorSaddleRightNorth: "--",
      errorSaddleRightSouth: "--",

      //running class
      runningClassLeft: "--",
      runningClassMiddle: "--",
      runningClassRight: "--",

      //humidity allowed max
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierMiddle: "--",
      humidityAllowedMaxDehumidifierRight: "--",
      humidityAllowedMaxAnchorLeftNorth: "--",
      humidityAllowedMaxAnchorLeftSouth: "--",
      humidityAllowedMaxAnchorRightNorth: "--",
      humidityAllowedMaxAnchorRightSouth: "--",
      humidityAllowedMaxSaddleLeftNorth1: "--",
      humidityAllowedMaxSaddleLeftNorth2: "--",
      humidityAllowedMaxSaddleLeftNorth3: "--",
      humidityAllowedMaxSaddleLeftSouth1: "--",
      humidityAllowedMaxSaddleLeftSouth2: "--",
      humidityAllowedMaxSaddleLeftSouth3: "--",
      humidityAllowedMaxSaddleRightNorth1: "--",
      humidityAllowedMaxSaddleRightNorth2: "--",
      humidityAllowedMaxSaddleRightNorth3: "--",
      humidityAllowedMaxSaddleRightSouth1: "--",
      humidityAllowedMaxSaddleRightSouth2: "--",
      humidityAllowedMaxSaddleRightSouth3: "--",

      //humidity tooltip error
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierMiddle: "--",
      humidityTooltipErrorDehumidifierRight: "--",
      humidityTooltipErrorAnchorLeftNorth: "--",
      humidityTooltipErrorAnchorLeftSouth: "--",
      humidityTooltipErrorAnchorRightNorth: "--",
      humidityTooltipErrorAnchorRightSouth: "--",
      humidityTooltipErrorSaddleLeftNorth1: "--",
      humidityTooltipErrorSaddleLeftNorth2: "--",
      humidityTooltipErrorSaddleLeftNorth3: "--",
      humidityTooltipErrorSaddleLeftSouth1: "--",
      humidityTooltipErrorSaddleLeftSouth2: "--",
      humidityTooltipErrorSaddleLeftSouth3: "--",
      humidityTooltipErrorSaddleRightNorth1: "--",
      humidityTooltipErrorSaddleRightNorth2: "--",
      humidityTooltipErrorSaddleRightNorth3: "--",
      humidityTooltipErrorSaddleRightSouth1: "--",
      humidityTooltipErrorSaddleRightSouth2: "--",
      humidityTooltipErrorSaddleRightSouth3: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityDehumidifierLeft: "2715a505-3bc1-4586-be8c-167546d1000b",
        humidityDehumidifierMiddle: "8d58cb94-f773-47ce-bc0f-76df7f3e5357",
        humidityDehumidifierRight: "f78c3416-1a7e-4263-a69e-efba1d20f909",
        humidityAnchorLeftNorth: "b6c58427-687b-4041-a01a-721fbcb07a07",
        humidityAnchorLeftSouth: "5906e89a-bd87-401e-ab63-5b9de81f8d98",
        humidityAnchorRightNorth: "a2a8ff2a-03ba-421b-87b4-cefceaa40bb8",
        humidityAnchorRightSouth: "d1969534-be6e-4679-98c6-59e716aa847a",
        humiditySaddleLeftNorth1: "e9299725-657e-4b02-9eb0-6eda5f27b2f7",
        humiditySaddleLeftNorth2: "7ce782c1-bb16-4da6-8b79-81ac1afc1363",
        humiditySaddleLeftNorth3: "db1574c1-049d-4af0-bde4-215eb8f31865",
        humiditySaddleLeftSouth1: "89b01dbb-e715-4412-ab94-61b94ffe0703",
        humiditySaddleLeftSouth2: "25b0c55c-7c52-4c30-aae3-a2be072962d1",
        humiditySaddleLeftSouth3: "dfdc9e93-96df-4f09-8397-caacb8c75440",
        humiditySaddleRightNorth1: "665dc765-34a3-4574-91b3-f97d94ea3210",
        humiditySaddleRightNorth2: "eec90c4d-ca9c-4e03-a3b8-c636beff4284",
        humiditySaddleRightNorth3: "10b97c34-a592-4a64-9c59-979458ca3fb1",
        humiditySaddleRightSouth1: "18c4ed78-2ab5-4782-be36-f451f57c8172",
        humiditySaddleRightSouth2: "b48f0d79-4475-40cb-8f3d-dd30388792e0",
        humiditySaddleRightSouth3: "26cac8e1-c64d-47b0-865a-06d1de4b3e7a",

        temperatureDehumidifierLeft: "f78ce28b-57db-4f47-83d7-b9b7bcd97c40",
        temperatureDehumidifierMiddle: "44c1ad61-cd81-4f40-82ab-0a2e3a6c0952",
        temperatureDehumidifierRight: "50c9c234-a076-4b9a-8271-3e3aa5affb4f",
        temperatureAnchorLeftNorth: "931bb531-3c2a-4b40-91a1-9900a28081ff",
        temperatureAnchorLeftSouth: "0c847754-63c7-4b2b-a27c-f941f26971d7",
        temperatureAnchorRightNorth: "b9047b2d-c0ad-4705-a9fe-8a79012c7a5c",
        temperatureAnchorRightSouth: "1f5e1060-0fe3-48c9-b1a5-06750847f34d",
        temperatureSaddleLeftNorth1: "836cb354-43fa-471a-b6c4-f88e954f2c76",
        temperatureSaddleLeftNorth2: "9e72628a-f38d-402b-956d-d55ec46e3b7f",
        temperatureSaddleLeftNorth3: "8fac5a6e-2e3d-439d-8841-15d7434205b6",
        temperatureSaddleLeftSouth1: "2827725b-c107-43ad-b209-a89f586f8788",
        temperatureSaddleLeftSouth2: "b5e2fcd0-27cc-4196-8d79-b30274cb6bc4",
        temperatureSaddleLeftSouth3: "ec93834a-7121-49fe-99c1-27d3e6ab1801",
        temperatureSaddleRightNorth1: "ffee82c3-03b1-47df-a1e3-9e3cf60e3d14",
        temperatureSaddleRightNorth2: "d718b61f-1b7b-435d-af10-3ec926cc246e",
        temperatureSaddleRightNorth3: "7f452338-a59a-453b-8afd-e962f9591493",
        temperatureSaddleRightSouth1: "e5c25f9e-878d-4c93-abba-0dbd4de1a02a",
        temperatureSaddleRightSouth2: "c016c088-7b8a-45e6-8230-b39c539df9eb",
        temperatureSaddleRightSouth3: "8bfb9886-53b0-4622-b990-e65a5f6f99a9",

        absHumidityAnchorLeftNorth: "0952b79f-414a-4301-b0e0-cb69c30e9a47",
        absHumidityAnchorLeftSouth: "c0b477b3-16c1-4e11-a700-71f63b29507d",
        absHumidityAnchorRightNorth: "1039863e-b9d1-4e80-a6dd-e99336f88ef1",
        absHumidityAnchorRightSouth: "a0d7430d-e962-4dd0-8eda-aff55384856a",
        absHumiditySaddleLeftNorth1: "f521ad91-8faa-4ead-a235-dcc090ecbcad",
        absHumiditySaddleLeftNorth2: "1aba5878-ca93-4184-8c8c-7d2a176cc059",
        absHumiditySaddleLeftNorth3: "616100ab-42fc-4480-a639-f803a547c9ec",
        absHumiditySaddleLeftSouth1: "19ac6c30-faf2-4152-b047-200ac2c3741c",
        absHumiditySaddleLeftSouth2: "ba0a067c-79cf-4f43-8c43-233d37e53d18",
        absHumiditySaddleLeftSouth3: "8967c91e-3d0e-4c01-b664-c07c5b44c683",
        absHumiditySaddleRightNorth1: "eda6ba82-5662-4e8a-a5ac-d1ede0d096f3",
        absHumiditySaddleRightNorth2: "1fd775dd-bcb3-4785-8803-43c3a128233a",
        absHumiditySaddleRightNorth3: "3499e8ed-cdd1-4c31-a5b7-9331827cafcd",
        absHumiditySaddleRightSouth1: "9160d80a-dafe-4ac8-8b20-e9c52be28260",
        absHumiditySaddleRightSouth2: "97bace24-26f3-4a48-b8a2-a9ea0aac8602",
        absHumiditySaddleRightSouth3: "f6e73bc7-da05-44b5-8052-907b167e3157",

        //running
        runningDehumidifierLeft: "bbffbc8c-5879-48e1-9491-e13ee6e92652",
        runningDehumidifierMiddle: "910a168f-9c22-405f-814f-5cb87ac29079",
        runningDehumidifierRight: "58ed1ec9-3096-46b2-8b56-eb5da3b268e7",

        //malfunction
        malfunctionDehumidifierLeft: "2618ad27-976f-471a-845d-956e3fe26c52",
        malfunctionDehumidifierMiddle: "1a7ef191-a545-41de-9e60-af7f0618ada3",
        malfunctionDehumidifierRight: "97856dae-797c-4f97-8eb4-d7d1864f7a02",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxDehumidifierLeft: "2715a505-3bc1-4586-be8c-167546d1000b",
        humidityAllowedMaxDehumidifierMiddle: "8d58cb94-f773-47ce-bc0f-76df7f3e5357",
        humidityAllowedMaxDehumidifierRight: "f78c3416-1a7e-4263-a69e-efba1d20f909",
        humidityAllowedMaxAnchorLeftNorth: "b6c58427-687b-4041-a01a-721fbcb07a07",
        humidityAllowedMaxAnchorLeftSouth: "5906e89a-bd87-401e-ab63-5b9de81f8d98",
        humidityAllowedMaxAnchorRightNorth: "a2a8ff2a-03ba-421b-87b4-cefceaa40bb8",
        humidityAllowedMaxAnchorRightSouth: "d1969534-be6e-4679-98c6-59e716aa847a",
        humidityAllowedMaxSaddleLeftNorth1: "e9299725-657e-4b02-9eb0-6eda5f27b2f7",
        humidityAllowedMaxSaddleLeftNorth2: "7ce782c1-bb16-4da6-8b79-81ac1afc1363",
        humidityAllowedMaxSaddleLeftNorth3: "db1574c1-049d-4af0-bde4-215eb8f31865",
        humidityAllowedMaxSaddleLeftSouth1: "89b01dbb-e715-4412-ab94-61b94ffe0703",
        humidityAllowedMaxSaddleLeftSouth2: "25b0c55c-7c52-4c30-aae3-a2be072962d1",
        humidityAllowedMaxSaddleLeftSouth3: "dfdc9e93-96df-4f09-8397-caacb8c75440",
        humidityAllowedMaxSaddleRightNorth1: "665dc765-34a3-4574-91b3-f97d94ea3210",
        humidityAllowedMaxSaddleRightNorth2: "eec90c4d-ca9c-4e03-a3b8-c636beff4284",
        humidityAllowedMaxSaddleRightNorth3: "10b97c34-a592-4a64-9c59-979458ca3fb1",
        humidityAllowedMaxSaddleRightSouth1: "18c4ed78-2ab5-4782-be36-f451f57c8172",
        humidityAllowedMaxSaddleRightSouth2: "b48f0d79-4475-40cb-8f3d-dd30388792e0",
        humidityAllowedMaxSaddleRightSouth3: "26cac8e1-c64d-47b0-865a-06d1de4b3e7a",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        // humidityDehumidifierLeft: "errorDehumidifierLeft",
        // humidityDehumidifierMiddle: "errorDehumidifierMiddle",
        // humidityDehumidifierRight: "errorDehumidifierRight",
        // temperatureDehumidifierLeft: "errorDehumidifierLeft",
        // temperatureDehumidifierMiddle: "errorDehumidifierMiddle",
        // temperatureDehumidifierRight: "errorDehumidifierRight",

        humidityAnchorLeftNorth: "errorAnchorLeftNorth",
        humidityAnchorLeftSouth: "errorAnchorLeftSouth",
        humidityAnchorRightNorth: "errorAnchorRightNorth",
        humidityAnchorRightSouth: "errorAnchorRightSouth",
        humiditySaddleLeftNorth1: "errorSaddleLeftNorth",
        humiditySaddleLeftNorth2: "errorSaddleLeftNorth",
        humiditySaddleLeftNorth3: "errorSaddleLeftNorth",
        humiditySaddleLeftSouth1: "errorSaddleLeftSouth",
        humiditySaddleLeftSouth2: "errorSaddleLeftSouth",
        humiditySaddleLeftSouth3: "errorSaddleLeftSouth",
        humiditySaddleRightNorth1: "errorSaddleRightNorth",
        humiditySaddleRightNorth2: "errorSaddleRightNorth",
        humiditySaddleRightNorth3: "errorSaddleRightNorth",
        humiditySaddleRightSouth1: "errorSaddleRightSouth",
        humiditySaddleRightSouth2: "errorSaddleRightSouth",
        humiditySaddleRightSouth3: "errorSaddleRightSouth",

        temperaturerAnchorLeftNorth: "errorAnchorLeftNorth",
        temperaturerAnchorLeftSouth: "errorAnchorLeftSouth",
        temperaturerAnchorRightNorth: "errorAnchorRightNorth",
        temperaturerAnchorRightSouth: "errorAnchorRightSouth",
        temperaturerSaddleLeftNorth1: "errorSaddleLeftNorth",
        temperaturerSaddleLeftNorth2: "errorSaddleLeftNorth",
        temperaturerSaddleLeftNorth3: "errorSaddleLeftNorth",
        temperaturerSaddleLeftSouth1: "errorSaddleLeftSouth",
        temperaturerSaddleLeftSouth2: "errorSaddleLeftSouth",
        temperaturerSaddleLeftSouth3: "errorSaddleLeftSouth",
        temperaturerSaddleRightNorth1: "errorSaddleRightNorth",
        temperaturerSaddleRightNorth2: "errorSaddleRightNorth",
        temperaturerSaddleRightNorth3: "errorSaddleRightNorth",
        temperaturerSaddleRightSouth1: "errorSaddleRightSouth",
        temperaturerSaddleRightSouth2: "errorSaddleRightSouth",
        temperaturerSaddleRightSouth3: "errorSaddleRightSouth",

        absHumidityAnchorLeftNorth: "errorAnchorLeftNorth",
        absHumidityAnchorLeftSouth: "errorAnchorLeftSouth",
        absHumidityAnchorRightNorth: "errorAnchorRightNorth",
        absHumidityAnchorRightSouth: "errorAnchorRightSouth",
        absHumiditySaddleLeftNorth1: "errorSaddleLeftNorth1",
        absHumiditySaddleLeftNorth2: "errorSaddleLeftNorth2",
        absHumiditySaddleLeftNorth3: "errorSaddleLeftNorth3",
        absHumiditySaddleLeftSouth1: "errorSaddleLeftSouth1",
        absHumiditySaddleLeftSouth2: "errorSaddleLeftSouth2",
        absHumiditySaddleLeftSouth3: "errorSaddleLeftSouth3",
        absHumiditySaddleRightNorth1: "errorSaddleRightNorth1",
        absHumiditySaddleRightNorth2: "errorSaddleRightNorth2",
        absHumiditySaddleRightNorth3: "errorSaddleRightNorth3",
        absHumiditySaddleRightSouth1: "errorSaddleRightSouth1",
        absHumiditySaddleRightSouth2: "errorSaddleRightSouth2",
        absHumiditySaddleRightSouth3: "errorSaddleRightSouth3",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierMiddle: "errorDehumidifierMiddle",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierMiddle: "humidityTooltipErrorDehumidifierMiddle",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
        humidityAnchorLeftNorth: "humidityTooltipErrorAnchorLeftNorth",
        humidityAnchorLeftSouth: "humidityTooltipErrorAnchorLeftSouth",
        humidityAnchorRightNorth: "humidityTooltipErrorAnchorRightNorth",
        humidityAnchorRightSouth: "humidityTooltipErrorAnchorRightSouth",
        humiditySaddleLeftNorth1: "humidityTooltipErrorSaddleLeftNorth1",
        humiditySaddleLeftNorth2: "humidityTooltipErrorSaddleLeftNorth2",
        humiditySaddleLeftNorth3: "humidityTooltipErrorSaddleLeftNorth3",
        humiditySaddleLeftSouth1: "humidityTooltipErrorSaddleLeftSouth1",
        humiditySaddleLeftSouth2: "humidityTooltipErrorSaddleLeftSouth2",
        humiditySaddleLeftSouth3: "humidityTooltipErrorSaddleLeftSouth3",
        humiditySaddleRightNorth1: "humidityTooltipErrorSaddleRightNorth1",
        humiditySaddleRightNorth2: "humidityTooltipErrorSaddleRightNorth2",
        humiditySaddleRightNorth3: "humidityTooltipErrorSaddleRightNorth3",
        humiditySaddleRightSouth1: "humidityTooltipErrorSaddleRightSouth1",
        humiditySaddleRightSouth2: "humidityTooltipErrorSaddleRightSouth2",
        humiditySaddleRightSouth3: "humidityTooltipErrorSaddleRightSouth3",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierMiddle: "runningClassMiddle",
        runningDehumidifierRight: "runningClassRight",
      },

      //station id list
      stationIdList: [
        "4ff8f361-e4aa-40a4-9048-90985db24a88",
        "2e241429-2eee-4cf4-bc8e-7e7ed1ee2dde",
        "167492d7-1c68-473a-a789-7d4165b60e1f",
        "7ab6a856-37cf-4735-a0fa-6dfc740cb3a8",
        "f3bf71b1-4f8f-474f-b5ec-b5acd27cea7e",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel === "" && allowedMax === "") {
        //no humidity dehumidifier
        // console.log('running flag: ' + runningFlag + ", error flag: " + errorFlag);
        if (runningFlag === null || errorFlag === null) {
          result += "数据中断";
        }

        if (runningFlag > 0) {
          result += " 除湿机运行";
        } else if (runningFlag === 0) {
          result += " 除湿机停止";
        }

        if (errorFlag > 0) {
          result += "  故障报警";
        }
      } else {
        //normal dehumidifier
        if (errorLevel.toLowerCase() !== "warning") {
          if (runningFlag > 0) {
            result += ", 除湿机运行";
          } else if (runningFlag === 0) {
            result += ", 除湿机停止";
          }
        }

        if (errorFlag > 0) {
          result += ", 故障报警";
        }
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1350px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/balinghe/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 15px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            .bold {
              font-weight: 800;
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 46%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-right-pos:before {
              left: 81.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-left {
          top: 95px;
          left: 230px;
        }

        .station-block-middle {
          top: 165px;
          left: 590px;
        }

        .station-block-right {
          top: 93px;
          left: 953px;
        }

        .sta-left {
          top: 108px;
          left: 282px;

          &::before {
            bottom: 20px;
            left: -65px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -35px;
            top: -65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-middle {
          top: 188px;
          left: 640px;

          &::before {
            bottom: 75px;
            left: -105px;
            width: 130px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -29px;
            top: -150px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right {
          top: 108px;
          left: 1005px;

          &::before {
            bottom: 25px;
            left: -60px;
            width: 40px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -42px;
            top: -65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-anchor-left {
          top: 188px;
          left: 62px;

          &::before {
            bottom: -20px;
            left: -24px;
            width: 70px;
            transform: rotate(265deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
          }

          .state-info {
            right: -158px;
            top: 69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-anchor-right {
          top: 168px;
          left: 1100px;

          &::before {
            bottom: -20px;
            left: -16px;
            width: 50px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
            width: 0px;
          }

          .state-info {
            right: -20px;
            top: 79px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-saddle-left {
          top: 92px;
          left: 233px;

          &::before {
            bottom: 25px;
            left: -17px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 110px;
            left: -6px;
            width: 0px;
          }

          .state-info {
            right: -63px;
            top: -75px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-saddle-right {
          top: 88px;
          left: 956px;

          &::before {
            bottom: 25px;
            left: -17px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 110px;
            left: -6px;
            width: 0px;
          }

          .state-info {
            right: -63px;
            top: -75px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-1 {
          top: 175px;
          left: 80px;

          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -25px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-2 {
          top: 145px;
          left: 140px;

          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -25px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-3 {
          top: 103px;
          left: 220px;

          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -25px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-1 {
          top: 100px;
          left: 248px;

          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 27px;
          }

          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-2 {
          top: 126px;
          left: 325px;

          &::before {
            bottom: 48px;
            left: -38px;
            width: 100px;
            transform: rotate(95deg);
          }

          &::after {
            bottom: 97px;
            left: 16px;
          }

          .state-info {
            right: -160px;
            top: -82px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-3 {
          top: 145px;
          left: 408px;

          &::before {
            bottom: -29px;
            left: -36px;
            width: 80px;
            transform: rotate(275deg);
          }

          &::after {
            bottom: -68px;
            left: -14px;
          }

          .state-info {
            right: 26px;
            top: 84px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-4 {
          top: 158px;
          left: 506px;

          &::before {
            bottom: 15px;
            left: -0px;
            width: 15px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -40px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-5 {
          top: 160px;
          left: 532px;

          &::before {
            bottom: -19px;
            left: -30px;
            width: 65px;
            transform: rotate(280deg);
          }

          &::after {
            bottom: -50px;
            left: -18px;
          }

          .state-info {
            right: 35px;
            top: 64px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-6 {
          top: 165px;
          left: 576px;

          &::before {
            bottom: 15px;
            left: -0px;
            width: 15px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -40px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-6 {
          top: 165px;
          left: 612px;

          &::before {
            bottom: -6px;
            left: -10px;
            width: 35px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -68px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-5 {
          top: 160px;
          left: 642px;

          &::before {
            bottom: -19px;
            left: -20px;
            width: 65px;
            transform: rotate(260deg);
          }

          &::after {
            bottom: -50px;
            left: 18px;
          }

          .state-info {
            right: -165px;
            top: 64px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-4 {
          top: 158px;
          left: 685px;

          &::before {
            bottom: 15px;
            left: -0px;
            width: 15px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -40px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-3 {
          top: 145px;
          left: 784px;

          &::before {
            bottom: -29px;
            left: -28px;
            width: 80px;
            transform: rotate(265deg);
          }

          &::after {
            bottom: -68px;
            left: 16px;
          }

          .state-info {
            right: -159px;
            top: 84px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-2 {
          top: 126px;
          left: 864px;

          &::before {
            bottom: 48px;
            left: -46px;
            width: 100px;
            transform: rotate(85deg);
          }

          &::after {
            bottom: 97px;
            left: -15px;
          }

          .state-info {
            right: 32px;
            top: -82px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-1 {
          top: 98px;
          left: 943px;

          &::before {
            bottom: 22px;
            left: -22px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -26px;
          }

          .state-info {
            right: 42px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-3 {
          top: 98px;
          left: 970px;

          &::before {
            bottom: 22px;
            left: -4px;
            width: 40px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 25px;
          }

          .state-info {
            right: -169px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-2 {
          top: 145px;
          left: 1052px;

          &::before {
            bottom: 22px;
            left: -4px;
            width: 40px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 25px;
          }

          .state-info {
            right: -168px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-1 {
          top: 160px;
          left: 1085px;

          &::before {
            bottom: 17px;
            left: 1px;
            width: 26px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 28px;
            left: 20px;
          }

          .state-info {
            right: -165px;
            top: -13px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }
      }
    }
  }
}
</style>
